/* eslint-disable no-underscore-dangle */
/* eslint-disable theme-colors/no-literal-colors */
import { makeSingleton } from '../utils';

class LabelColors {
  private _labelColors: Record<string, string>;

  private _labelFontColors: Record<string, string>;

  public set labelColors(value: Record<string, string>) {
    this._labelColors = value;
  }

  public get labelColors() {
    return this._labelColors;
  }

  public set labelFontColors(value: Record<string, string>) {
    this._labelFontColors = value;
  }

  public get labelFontColors() {
    return this._labelFontColors;
  }
}

const getInstance = makeSingleton(LabelColors);

export default getInstance;
